import { HttpService } from "../../utils/DesigningHttpService.js";

export interface GuideViewModel {
  id: number;
  title: string;
  description: string;
  path: string;
  isActive: boolean;
}

export interface SaveGuideRequest {
  title: string;
  description: string;
  path: string;
}

interface PageGuide {
  title: string;
  description: string;
}

function normalizePath(path: string): string {
  const trimmed = (path ?? "").trim();
  if (!trimmed) {
    return trimmed;
  }
  return trimmed.startsWith("/") ? trimmed : `/${trimmed}`;
}

function escapeHtml(value: string): string {
  return value.replace(/[&<>"']/g, function (character) {
    const entities: Record<string, string> = {
      "&": "&amp;",
      "<": "&lt;",
      ">": "&gt;",
      '"': "&quot;",
      "'": "&#39;",
    };
    return entities[character];
  }).replace(/\r?\n/g, "<br />");
}

class GuideService {
  private httpService = new HttpService();

  getAll() {
    return this.httpService.get("/guide");
  }

  async getByPath(path: string): Promise<GuideViewModel[]> {
    const normalizedPath = normalizePath(path);
    if (normalizedPath === "/admin" || normalizedPath.startsWith("/admin/")) {
      return [];
    }
    const query = encodeURIComponent(normalizedPath);
    const guide: PageGuide | "" = await this.httpService.getResource(`/catalog/guides?path=${query}`);
    if (!guide) {
      return [];
    }
    return [{
      id: 0,
      title: guide.title,
      description: escapeHtml(guide.description),
      path: normalizedPath,
      isActive: true,
    }];
  }

  create(payload: SaveGuideRequest) {
    return this.httpService.post("/guide", {
      ...payload,
      path: normalizePath(payload.path),
    });
  }

  update(id: number, payload: SaveGuideRequest) {
    return this.httpService.put(`/guide/${id}`, {
      ...payload,
      path: normalizePath(payload.path),
    });
  }

  activate(id: number, isActive: boolean) {
    return this.httpService.put(`/guide/${id}/activate`, isActive);
  }

  remove(id: number) {
    return this.httpService.delete(`/guide/${id}`);
  }
}

export const guideService = new GuideService();
